import { Controller } from "@hotwired/stimulus"

// Shows the chosen file name next to the French "Choisir un fichier" button
// that stands in for the browser's own file input text. A file dropped on the
// field is chosen as if picked: without this, the browser opens it instead.
export default class extends Controller {
  static targets = ["input", "name"]
  static classes = ["filled", "dragging"]
  static values = { empty: String }

  update () {
    const file = this.inputTarget.files?.[0]

    this.nameTarget.textContent = file?.name || this.emptyValue
    if (this.hasFilledClass) this.element.classList.toggle(this.filledClass, Boolean(file))
  }

  dragOver (event) {
    if (!this.carriesFiles(event)) return

    event.preventDefault()
    if (this.inputTarget.disabled) {
      event.dataTransfer.dropEffect = "none"
      return
    }

    event.dataTransfer.dropEffect = "copy"
    if (this.hasDraggingClass) this.element.classList.add(this.draggingClass)
  }

  // Leaving for one of the field's own children is not leaving the field.
  dragLeave (event) {
    if (this.element.contains(event.relatedTarget)) return

    this.stopDragging()
  }

  drop (event) {
    if (!this.carriesFiles(event)) return

    event.preventDefault()
    this.stopDragging()
    const files = event.dataTransfer.files
    if (this.inputTarget.disabled || !files.length) return

    this.inputTarget.files = files.length > 1 ? this.firstOf(files) : files
    // `change` as a pick sends it: `update` runs, and so does any other listener.
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  carriesFiles (event) {
    return Array.from(event.dataTransfer?.types || []).includes("Files")
  }

  stopDragging () {
    if (this.hasDraggingClass) this.element.classList.remove(this.draggingClass)
  }

  // The field takes one file: several dropped keep the first.
  firstOf (files) {
    const transfer = new DataTransfer()
    transfer.items.add(files[0])
    return transfer.files
  }
}
